<template>
  <div>
    <list-container title="Equipment" :items='items' :filterable-tags="filterableTags">
      <template v-slot:default="slotProps">
        <div class='details clearfix'>
          <div class="stats">
            <div>
              <h3 v-html="colorize(slotProps.item.get('name'))"></h3>
            </div>

            <ul class='seperated'>
              <li>
                <b>WIELDED</b> in {{ slotProps.item.get('limb_count') }} Hand{{ slotProps.item.get('limb_count') > 1 ? 's' : '' }}
              </li>

              <li v-if='slotProps.item.isWorn()'>
                <b>EQUIPS</b> {{ equipsData(slotProps.item) }}
              </li>

              <li v-if='slotProps.item.get("range")'>
                <b>RANGE</b> of {{ slotProps.item.get('range') }}
              </li>

              <li v-if='slotProps.item.get("encumbrance")'>
                <b>ENCUMBERANCE</b> of {{ slotProps.item.get('encumbrance') }}
              </li>

              <li v-if='slotProps.item.protections().length > 0'>
                <p><b>PROTECTIONS</b></p>
                <ul>
                  <li v-for="protection in slotProps.item.protections()">{{ protection.protection_value }} {{ protection.protection_type }}</li>
                </ul>
              </li>

              <li v-if='slotProps.item.get("notes")'>
                <p><b>NOTES</b></p>
                <p v-html="colorize(slotProps.item.get('note'))"></p>
              </li>
            </ul>
          </div>

          <div class='effects' v-if='slotProps.item.actions().length > 0'>
            <div v-for='action in slotProps.item.actions()' class='action-info'>
              <p><span class="game-action">Action</span> <b v-html="colorize(action.get('name'))"></b>: <span v-html="colorize(action.get('effects'))"></span></p>

              <div v-if='action.get("requirements").length > 0'>
                <div class="body">
                  <ul>
                    <li v-for="requirement in action.get('requirements')" v-html="colorize(requirement)"></li>
                  </ul>
                </div>
              </div>

              <div v-if='outcomesFor(action).length > 0' class="detail-section">
                <div class="body">
                  <outcomes :outcomes="outcomesFor(action)"></outcomes>
                </div>
              </div>

              <div v-if='obstaclesFor(action).length > 0' class="detail-section">
                <div class="body">
                  <p>Obstacles</p>
                  <obstacles :obstacles="obstaclesFor(action)"></obstacles>
                </div>
              </div>

              <div v-if='hazardsFor(action).length > 0' class="detail-section">
                <div class="body">
                  <hazards :hazards="hazardsFor(action)"></hazards>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </list-container>
  </div>
</template>

<script>
import equipmentCollection from './collection.js';
import ListFilter from '../shared/list-filter.vue';
import Outcomes from '../shared/outcomes.vue';
import Obstacles from '../shared/obstacles.vue';
import Hazards from '../shared/hazards.vue';
import ListContainer from '../shared/list-container.vue';
import colorizeKeywords from '../shared/colorize.js';

import { compact, sortBy, without } from 'lodash';

export default {
  name: 'equipment-app',

  components: { ListContainer, ListFilter, Outcomes, Obstacles, Hazards },

  data: function(){
    return {
      collection: new equipmentCollection(),
      items: [],
      filteredItems: [],
      filterableTags: [],
      expandedItems: []
    }
  },

  beforeMount() {
    const comp = this;

    this.collection.fetch().then(() => {
      this.items = comp.collection.alphabetical();
      this.filteredItems = this.items;
      this.filterableTags = this.collection.tags().sort();
    });
  },

  methods: {
    outcomesFor(item) {
      return sortBy(item.outcomes(), 'cost');
    },

    obstaclesFor(item) {
      return sortBy(item.obstacles(), 'cost');
    },

    hazardsFor(item) {
      return sortBy(item.hazards(), 'cost');
    },

    colorize(text) { return colorizeKeywords(text); },

    itemIsA: function(item, type){
      return item.get('equipment_type') === type;
    },

    setVisibleItems: function(items) {
      this.filteredItems = items;
    },

    toggleItemExpansion(item) {
      if (this.expandedItems.indexOf(item) === -1) {
        this.expandedItems.push(item);
      }
      else {
        this.expandedItems = without(this.expandedItems, item)
      }
    },

    expansionClassFor(item) {
      if (this.expandedItems.indexOf(item) === -1) {
        return ['expandable']
      }
      return []
    },

    actionsIcon(item) {
      if (this.expandedItems.indexOf(item) === -1) {
        return '+';
      }

      return '-';
    },

    equipsData(item) {
      return compact([item.get('body_part'), item.get('apparel_slot')]).join(' - ');
    }
  }
}
</script>

<style scoped>
.flat-list-item::before {
  content: •;
}
</style>
